import type { CheckboxFieldConfig } from '../../config';
import type { SectionKey } from '../../lease-details.types';
import { LeaseCheckboxInput } from '../../inputs/lease-checkbox-input';
import { useFieldEventContextBuilder } from '../use-field-event-context';

export type CheckboxFieldProps = {
  path: string;
  field: CheckboxFieldConfig;
  sectionKey: SectionKey;
  arrayIndex?: number;
  disabled: boolean;
};

export function CheckboxField({
  path,
  field,
  sectionKey,
  arrayIndex,
  disabled,
}: CheckboxFieldProps) {
  const buildContext = useFieldEventContextBuilder<boolean>(path, sectionKey, arrayIndex);
  return (
    <LeaseCheckboxInput
      name={path}
      label={field.label}
      disabled={disabled}
      checkedColor={field.checkedColor}
      onChangeValue={
        field.events?.onChange
          ? (checked) => field.events?.onChange?.(buildContext(checked))
          : undefined
      }
    />
  );
}
